<template>
     <back-layout title="Páginas">
        <template #header>
            <div class="flex justify-between">
                <h2 class="font-semibold text-4xl text-gray-300 leading-tight">Páginas</h2>
                <Link :href="route('create.page')" class="border border-primary-900 text-primary-900 uppercase text-sm py-2 px-4 font-bold rounded-full flex items-center hover:bg-white hover:bg-opacity-50 transition"><icon name="plus-circle" class="w-5 h-5 mr-2" /> Criar Página</Link>
            </div>
        </template>

        <!-- SEARCH BOX GOES HERE -->

 
            <div class="container mx-auto">
                <div class="px-4 my-2 flex items-center uppercase text-xs font-bold justify-between">
                    <p class="flex-1">Título</p>
                    <p class="flex-1">Data</p>
                    <p class="flex-1">status</p>
                    <p class="flex-1">Ações</p>
                </div>
                <div v-for="page in pages" class="bg-white overflow-hidden shadow rounded-lg p-4 my-2 flex items-center self-start space-x-2">
                    <Link :href="route('edit.page', page.id)" class="flex-1 font-bold">{{ page.title }}</Link>
                    <p class="flex-1">{{ dateFormated(page.created_at) }}</p>
                    <p class="flex-1 uppercase font-bold text-xs" v-html="page.is_published == 1 ? `<span class='bg-violet-500 text-white py-1 px-2 rounded-full'>Público</span>` : `<span class='bg-gray-300 text-white py-1 px-2 rounded-full'>Rascunho</span>`"></p>
                     <div class="flex-1">
                        <jet-button @click.prevent="editPage(page)" class="py-1 px-2 text-xs rounded-full border border-gray-400 bg-transparent hover:bg-gray-100 focus:bg-transparent active:bg-transparent active:border-gray-400 focus:border-gray-400 focus:ring-transparent active:shadow-0 focus:shadow-0 text-gray-400 mr-2"><icon name="edit" class="w-3 h-3" /> Editar</jet-button>

                        <jet-button @click.prevent="removePage(page)" class="py-1 px-2 text-xs rounded-full border border-amber-600 bg-transparent hover:bg-gray-100 focus:bg-transparent active:bg-transparent active:border-amber-600 focus:border-amber-600 focus:ring-transparent active:shadow-0 focus:shadow-0 text-amber-600 mr-2"><icon name="trash" class="w-3 h-3" /> Remover</jet-button>
                    </div>
                </div>
            </div>
 
    </back-layout>
</template>


<script>
    import { defineComponent } from 'vue'
    import BackLayout from '@/Layouts/BackLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import JetButton from '@/Jetstream/Button.vue'
    import Icon from '@/Jetstream/Icon'

    export default defineComponent({
        components: {
            Head,
            Link,
            BackLayout,
            JetButton,
            Icon
        },
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
            pages: Array
        },
        data() {
            return {
            }
        },
        methods: {
            editPage(page) {
                this.$inertia.get(route('edit.page', page));
            },
            removePage(page) {
                if(confirm('Tem certeza? Esta ação é irreversível.')){
                    this.$inertia.delete(route('destroy.page', page));
                }
            },
            dateFormated(pageDate) {
                let date = new Date(pageDate)
                return date.toLocaleDateString()
            }
        },
    })
</script>